import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';

const PaymentDecline = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-lg">
                <div className="text-center">
                    <AlertCircle className="mx-auto h-16 w-16 text-secondary" />
                    <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
                        Payment Declined
                    </h2>
                    <p className="mt-2 text-sm text-gray-600">
                        Your payment was declined. Your booking request has been saved.
                    </p>
                </div>

                <div className="mt-8 bg-navy-50 border border-navy-200 rounded-md p-4">
                    <h3 className="text-sm font-medium text-navy-800 mb-2">Common reasons for declined payments:</h3>
                    <ul className="text-sm text-navy-700 list-disc list-inside space-y-1">
                        <li>Insufficient funds</li>
                        <li>Incorrect card details</li>
                        <li>Card expired</li>
                        <li>Bank security restrictions</li>
                    </ul>
                </div>

                <div className="mt-8 bg-navy-50 border border-navy-200 rounded-md p-4">
                    <p className="text-sm text-navy-800">
                        Your booking has been saved. Our team will contact you with alternative payment options.
                    </p>
                </div>

                <div className="mt-8 space-y-3">
                    <div className="text-center">
                        <p className="text-sm font-semibold text-gray-900">
                            Need assistance?
                        </p>
                        <p className="text-lg font-bold text-secondary">
                            Call: 03338820922
                        </p>
                        <p className="text-sm text-gray-600 mt-2">
                            or WhatsApp: +923338820922
                        </p>
                    </div>
                </div>

                <div className="mt-8 space-y-3">
                    <button
                        onClick={() => navigate('/flight-detail-search')}
                        className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-secondary hover:bg-navy-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary"
                    >
                        Try Again with Different Card
                    </button>
                    <button
                        onClick={() => navigate('/')}
                        className="w-full flex justify-center py-3 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary"
                    >
                        Return to Home
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentDecline;
